<!-- ------------------------------------ -->
<!-- -----根据不同的项目，跳转不同的登录页面--- -->
<!-- ------------------------------------ -->
<template>
  <div>
    <!-- 数字孪生 登录页面 -->
    <div v-if="envData.page_type === 'digital-twin'">
      <digital-twin></digital-twin>
    </div>

    <!-- 未来社区 登录页面 -->
    <div v-if="envData.page_type === 'future'">
      <future></future>
    </div>

    <!-- 鄞领优学 登录页面 -->
    <div v-if="envData.page_type === 'ylyx'">
      <ylyx></ylyx>
    </div>

    <!-- 疾控 登录页面 -->
    <div v-if="envData.page_type === 'cdc'">
      <cdc></cdc>
    </div>

    <div v-else>请配置环境变量page_type</div>
  </div>
</template>

<script>
import DigitalTwin from "@/components/digital-twin";
import Future from "@/components/future";
import Ylyx from "@/components/ylyx";
import Cdc from "@/components/cdc";

export default {
  components: {
    DigitalTwin,
    Future,
    Ylyx,
    Cdc
  },

  data() {
    return {
      envData: {
        page_type: "",
      },
    };
  },
  mounted() {
    const ENV_DATA = process.env.VUE_APP_ENV_DATA;

    if (ENV_DATA) {
      const envData = JSON.parse(ENV_DATA);
      if (envData.page_type === "resourcePlaning") {
        // 跳转到resourcePlaning
        this.$router.replace({ path: "/resourcePlaning" });
      }
      this.envData = envData;
      console.log("envData", envData);
    }
  },
  methods: {},
};
</script>

<style lang="less" scoped></style>
